import React from "react";
import PropTypes from "prop-types";
import RadioButton from "shared/@forms/RadioButton";
import styles from "./PersonSelect.module.css";

// Some IBO accounts are shared by two people. When that's the case we let the
// rep pick which person they're acting as. Renders nothing for single-person
// accounts so callers can drop it in unconditionally.
export function PersonSelect({ people = [], value, onChange, name }) {
  // Both Order Management tabs stay mounted (hidden with display:none), so two
  // PersonSelects can exist at once. Native radio groups are document-wide by
  // name — if they shared a name, checking a radio in the visible tab would
  // natively uncheck the hidden tab's radio and fight React's controlled
  // state. A per-instance suffix keeps each mount in its own group.
  const uid = React.useId();

  if (!Array.isArray(people) || people.length < 2) {
    return null;
  }

  return (
    <div
      className={styles.personSelect}
      role="radiogroup"
      aria-label="Choose user"
    >
      <span className={styles.label}>Choose User:</span>
      {people.map((person) => (
        <label
          className={styles.option}
          key={person.id}
          title={`Act as ${person.name} on this IBO account.`}
        >
          <RadioButton
            className={styles.radio}
            name={`${name}${uid}`}
            value={person.id}
            checked={value === person.id}
            onChange={() => onChange(person.id)}
          />
          <span>{person.name}</span>
        </label>
      ))}
    </div>
  );
}

PersonSelect.propTypes = {
  people: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default PersonSelect;
